module.exports = __webpack_public_path__ + "img/auth_banner_zx.09320eaa.jpg";